import {
    UPDATE_UNAWARDED_SHIFTLINES_REPORT,
    RESET_UNAWARDED_SHIFTLINES_REPORT,
} from './unawardedShiftlinesReport.actions';

/** @type {UnawardedShiftlinesReport.IUnawardedShiftlinesReport} */
const initialState = {
    unawardedShiftlines: [],
    filters: {
        search: '',
        pageIndex: 1,
        pageSize: 50,
    },
};

/**
 *
 * @param {UnawardedShiftlinesReport.IUnawardedShiftlinesReport} state
 * @param {ShiftBidding.IAction} action
 */
// eslint-disable-next-line default-param-last
export default function unawardedShiftlinesReportReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case UPDATE_UNAWARDED_SHIFTLINES_REPORT:
            return {
                ...state,
                ...payload,
            };
        case RESET_UNAWARDED_SHIFTLINES_REPORT:
            return initialState;
        default:
            return state;
    }
}
